import canParse from 'core-js-pure/actual/url/can-parse';

export function replaceLastPathSegment(url: string, newSegment: string) {
  const isFullUrl = canParse(url);
  const _url = isFullUrl ? new URL(url) : new URL(url, 'http://remove.me');

  if (_url.pathname.length === 1) {
    if (isFullUrl && url.endsWith('/') === true) {
      url = url.slice(0, -1);
    }

    return url;
  }

  const removed = removePathSegments(url, 1);

  if (newSegment === '/' || newSegment === '') {
    return removed;
  }

  return addPathSegments(removed, newSegment);
}

export function removePathSegments(url: string, count: number) {
  const isFullUrl = canParse(url);
  const _url = isFullUrl ? new URL(url) : new URL('http://remove.me' + url);

  if (_url.pathname.endsWith('/')) {
    _url.pathname = _url.pathname.slice(0, -1);
  }

  for (let i = 0; i < count; i++) {
    _url.pathname = _url.pathname.substring(0, _url.pathname.lastIndexOf('/'));
  }

  let newUrl = isFullUrl ? _url.href : _url.pathname;

  if (newUrl.endsWith('/') && newUrl.length > 1) {
    newUrl = newUrl.slice(0, -1);
  }

  return newUrl;
}

export function addPathSegments(url: string, ...pathSegments: (string|number)[]) {
  const isFullUrl = canParse(url);
  const _url = isFullUrl ? new URL(url) : new URL(url, 'http://remove.me');

  if (_url.pathname.endsWith('/') === false) {
    _url.pathname += '/';
  }

  pathSegments.forEach((segment) => {
    const cleanSegment = segment.toString().replaceAll('/', '');

    _url.pathname += `${cleanSegment}/`;
  });

  let newUrl = isFullUrl ? _url.href : _url.pathname;

  if (newUrl.endsWith('/') && newUrl.length > 1) {
    newUrl = newUrl.slice(0, -1);
  }

  return newUrl;
}
